export type Http = <T>(request: HttpRequest) => Promise<T>;

export interface HttpRequest {
    url: string;
    method: string;
    headers?: { [key: string]: string | undefined };
    body?: string;
}

export interface HttpResponse<T> {
    data: T;
    status: number;
}

export async function http<T>(request: HttpRequest): Promise<HttpResponse<T>> {
    const headers = new Headers();

    if (request.headers) {
        for (const [key, value] of Object.entries(request.headers)) {
            if (value !== undefined) {
                headers.set(key, value);
            }
        }
    }

    const init: RequestInit = {
        method: request.method,
        headers,
        body: request.body ? request.body : undefined,
    };

    try {
        const response = await fetch(request.url, init);

        if (!response.ok) {
            throw new Error(
                `HTTP error ${response.status}: ${response.statusText}`
            );
        }

        const data = await response.json();
        return { data, status: response.status };
    } catch (error) {
        throw new Error(`Error during HTTP request: ${error.message}`);
    }
}
